;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import { useRef } from 'react'
import { useOnClickOutside } from 'usehooks-ts'

interface Props {
  children: React.ReactNode;
  onClickOutside: () => void;
}

export default function ClickOutsideHandler({
                                              children,
                                              onClickOutside,
                                            }: Props) {
  const childRef = useRef<HTMLDivElement>(null)

    // @ts-expect-error Error
    useOnClickOutside(childRef, onClickOutside)

  return <div ref={childRef}>{children}</div>
}
